import { api } from "..";

export interface OddsAdjustmentSelection {
  key: string;
  adjustmentValue: number;
  active?: boolean;
}

export interface UpsertOddsAdjustmentsPayload {
  selections: OddsAdjustmentSelection[];
  targetUsername?: string;
}

export interface UpsertOddsAdjustmentsResponse {
  success: boolean;
  adjustments: Record<string, { adjustmentValue: number; active?: boolean }>;
}

export async function upsertOddsAdjustments(
  payload: UpsertOddsAdjustmentsPayload
): Promise<UpsertOddsAdjustmentsResponse> {
  const res = await api.client.post(
    "/sport-events-new/odds-adjustment",
    payload
  );
  return res.data;
}
